import { APP_INITIALIZER } from '@angular/core'
import { ORDERED_APP_INITIALIZER, orderedAppInitializer } from './ordered-initializer'
import { Platform } from '@angular/cdk/platform'
import { TranslateService } from '@ngx-translate/core'
import { catchError, filter, first, switchMap } from 'rxjs/operators'
import { lastValueFrom, of } from 'rxjs'
import { Router } from '@angular/router'
import { DeviceDetectorService } from 'ngx-device-detector'

import { ThemeService } from '@shared/services/theme.service'
import { InititializerService } from '../services/inititializer.service'
import { AuthService } from '@app/modules/auth/auth.service'
import { ApiService } from '@app/shared/services/api.service'

const bootstrapFactory =
  (
    apiService: ApiService,
    authService: AuthService,
    platform: Platform,
    themeService: ThemeService,
    translateService: TranslateService,
    router: Router,
    deviceService: DeviceDetectorService,
  ) =>
  () => {
    setLanguage(translateService)
    checkIfMobile(platform, router, deviceService)
    apiService.init()

    return lastValueFrom(bootstrapServices(authService, themeService), { defaultValue: undefined })
  }

function bootstrapServices(authService: AuthService, themeService: ThemeService) {
  const login$ = authService.populate().pipe(
    switchMap(() => authService.isLoggedIn$),
    first(),
    filter(Boolean),
    switchMap(() => themeService.applyTheme()),
    catchError(() => of(true)),
  )

  return login$
}

function setLanguage(translateService: TranslateService) {
  translateService.setDefaultLang('en')
  translateService.use('en')
}

function checkIfMobile(platform: Platform, router: Router, deviceService: DeviceDetectorService) {
  const hasNotPartOfUrl = (part: string) => !window.location.href.includes(part)
  if (deviceService.isMobile() && hasNotPartOfUrl('password') && hasNotPartOfUrl('track')) {
    void router.navigate(['/check-mobile-phone'])
  }

  if (platform.ANDROID || platform.IOS) {
    document.body.classList.add('is-mobile')
  }
}

export const BOOTSTRAP_PROVIDERS = [
  {
    provide: ORDERED_APP_INITIALIZER,
    useFactory: (inititializerService: InititializerService) => () => inititializerService.getPlatformSettings(),
    multi: true,
    deps: [InititializerService],
  },
  {
    provide: ORDERED_APP_INITIALIZER,
    useFactory: bootstrapFactory,
    multi: true,
    deps: [ApiService, AuthService, Platform, ThemeService, TranslateService, Router, DeviceDetectorService],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: orderedAppInitializer,
    deps: [ORDERED_APP_INITIALIZER],
    multi: true,
  },
]
